<template>
  <InputField label="Security Code" :error="hasError" :error-message="validationMessage" :active="isFocused" :filled="!isEmpty">
    <div id="recurly-card-input-field-cvv"></div>
  </InputField>
</template>
<script setup lang="ts">
import InputField from '@/components/shared/inputs/InputField.vue'

import { toRaw, ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useErrorsStore } from '@/store/ErrorsStore'
import { useRecurlyStore } from '@/store/RecurlyStore'

const recurlyStore = useRecurlyStore()
const { recurlyElements } = storeToRefs(recurlyStore)

const props = defineProps({
  styles: {
    type: Object,
    required: true
  }
})

const errorsStore = useErrorsStore()
const { find: findError } = errorsStore
const { errorType } = storeToRefs(errorsStore)

const attached = ref(false)
const isValid = ref(false)
const isEmpty = ref(true)
const isFocused = ref(false)

defineExpose({ isValid })

onMounted(() => {
  attachRecurly()
})

const transactionError = computed(() => {
  return errorType.value === 'transaction'
})

const validationError = computed(() => {
  return (findError('cvv') && !isValid.value) || (!isValid.value && !isEmpty.value)
})

const hasError = computed(() => {
  return validationError.value || transactionError.value
})

const validationMessage = computed(() => {
  return validationError.value ? 'Your security code is not valid' : undefined
})

const attachRecurly = () => {
  if (attached.value || !recurlyElements.value) {
    return false
  }

  const cvvElement = toRaw(recurlyElements.value).CardCvvElement({
    style: {
      ...props.styles,
      placeholder: {
        content: 'CVV',
        fontWeight: 'normal',
        color: (props.styles.placeholderColor || '#FFFFFF') + ' !important'
      }
    }
  })

  attached.value = true
  cvvElement.attach('#recurly-card-input-field-cvv')

  cvvElement.on('change', ({ empty, valid }: { empty: boolean; valid: boolean }) => {
    isEmpty.value = empty
    isValid.value = valid
  })

  cvvElement.on('focus', () => {
    isFocused.value = true
  })

  cvvElement.on('blur', () => {
    isFocused.value = false
  })
}
</script>
